export type GetDeploymentRequestsRequest = {
  dplymntReqType: string;
  dplymntMode?: string;
  pjtId?: string;
  schedDtimeStart?: string;
  schedDtimeEnd?: string;
  dplymntStsList?: string[];
  dplymntEnv?: string;
  dipByRgn?: string;
  cmpId?: string;
  inOutTypeCd?: string;
  edhPrtclTypeCd?: string;
};
